import { render, staticRenderFns } from "./submission-block.vue?vue&type=template&id=b4a93b46"
import script from "./submission-block.vue?vue&type=script&lang=js"
export * from "./submission-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports